import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ReportConstructionPOInfo } from '@app/cp/shared/models/ReportConstructionPOInfo';
import { GItem } from '@app/cp/shared/models/GItem';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { SItem } from '@app/cp/shared/models/SItem';
import { RowClassArgs, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { process, aggregateBy, filterBy } from '@progress/kendo-data-query';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { OrderService } from '../../shared/services/order.service';
import { ReportOrderBillInfo } from '../../shared/models/ReportOrderBillInfo';

@UseFeatureFlagSet()
@Component({
    selector: 'open-po-bills',
    templateUrl: './open-po-bills.component.html',
    styleUrls: ['./open-po-bills.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OpenPOBillsComponent extends BaseGridUIComponent<ReportOrderBillInfo, null, ConstructionService> implements OnInit, OnDestroy {

    compFeatureFlagSet: IFeatureFlagSet = this as any;
    zuggitText: string = "";
    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    public pageSize = 50;
    contractStatusNameCF: MSCLFilterClass;
    constructor(globals: GlobalsService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService, svc_order: OrderService) {
        super(globals);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;
        this.svc_order = svc_order;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

        this.aggregates = [
            { field: 'amountBilled', aggregate: 'sum' }
            , { field: 'orderNumber', aggregate: 'count' }
            , { field: 'amountPaid', aggregate: 'sum' }

        ];
        this.state.group = [{ field: 'poTotal', aggregates: this.aggregates }];
        if (globals?.user?.isZuggitUser) {
            this.zuggitText = "Zuggit ";
        }
        
    }
    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    svc_order: OrderService;
    get referenceDataG(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    buyers: GItem[];
    buyerPersonId: any;
    receivedByPersonId: any;
    billCreatedStart: any;
    billCreatedEnd: any;
    invoiceDateStart: any;
    invoiceDateEnd: any;
    dispatchNumber: any;
    supplierId: any;
    orderNumber: any;
    orderStatusIds: any;
    orderBillStatusIds: any;
    dispatchStatusIds: any;
    customerId: any;
    srvConstId: any
    techCreatedId: any = "0";
    poTypes: SItem[];
    poType: string;
    techCreateds:GItem[] = [];
    exportFilteredData: any[];

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public contentTypes = WindowContents;

    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceDataG !== undefined && this.referenceDataG !== null && this.referenceDataG.dispatchStatus !== undefined && this.referenceDataG.dispatchStatus !== null ? true : false;
        }
        catch{
            retVal = false;
        }
        return retVal;

    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
    }

    ngOnInit() {
        this.getReferenceData();
    }
    getReferenceData() {
        this.dataLoading = true;
        this.svc_data.getConstPOInformationReference().subscribe((info: BaseMessageInfo) => {

            this.buyers = info.dcValues.Buyers;
            this.poTypes = info.dcValues.POTypes;
            this.dataLoading = false;
            this.techCreateds.push(new GItem({value:0,description:"",category:null,canSelect:true,reference:null }))
            this.techCreateds.push(new GItem({ value: 1, description: "Tech Created Only", category: null, canSelect: true, reference: null }))
            this.techCreateds.push(new GItem({ value: 2, description: "Hide Tech Created", category: null, canSelect: true, reference: null }))
        });
    }

    origData: any;
    override getData() {
        this.dataLoading = true;
        this.saveError = null;
        let param: CommonParam = this.getParam();
        
        this.svc_order.getPOBillInformation(param).subscribe((info: BaseMessageInfo) => {

            let arr = [];
            if (info.saveError) {
                this.saveError = info.message;
            }
            else {
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let newObj: ReportOrderBillInfo = new ReportOrderBillInfo(info.primaryReturn[i]);
                arr.push(newObj);
            }}

            this.gridData = arr;
            this.originalGridData = arr;

            this.processGridData();
            this.dataLoading = false;
        });
    }
    getParam(initial: boolean = false) : CommonParam {
        let param: CommonParam = new CommonParam();
        if (!initial) {
            var isSub: boolean = null;
            switch (CommonFunctions.getStringValueIfNull(this.poType, "A")) {
                case "S":
                    isSub = true;
                    break;
                case "N":
                    isSub = false;
                    break;
            }
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.customerId = this.customerId;
            param.addParam("BuyerPersonId", this.buyerPersonId);
            param.addParam("ReceivedByPersonId", this.receivedByPersonId);
            param.addParam("OrderStatusIds", CommonFunctions.getCommaDelimitedStringFromArray(this.orderStatusIds));
            param.addParam("OrderBillStatusIds", CommonFunctions.getCommaDelimitedStringFromArray(this.orderBillStatusIds));
            param.addParam("DispatchStatusIds", CommonFunctions.getCommaDelimitedStringFromArray(this.dispatchStatusIds));
            param.addParam("BillCreatedStart", this.billCreatedStart);
            param.addParam("BillCreatedEnd", this.billCreatedEnd);
            param.addParam("InvoiceDateStart", this.invoiceDateStart);
            param.addParam("InvoiceDateEnd", this.invoiceDateEnd);
            param.addParam("DispatchNumber", this.dispatchNumber);
            param.addParam("OrderNumber", this.orderNumber);
            param.addParam("IsSub", isSub);
            param.addParam("SupplierId", this.supplierId);
           
        }
        return param;
    }
    apiFilter() {
        this.getData();
    }
    clearFilters() {
        this.receivedByPersonId = null;
        this.buyerPersonId = null;
        this.orderStatusIds = [];
        this.customerId = null;
        this.orderBillStatusIds = [];
        this.dispatchStatusIds = [];
        this.poType = null;
        this.srvConstId = null;
        this.techCreatedId = null;
        this.billCreatedStart = null;
        this.billCreatedEnd = null;
        this.invoiceDateStart = null;
        this.invoiceDateEnd = null;
        this.dispatchNumber = null;
        this.orderNumber = null;
        this.supplierId = null;

    }
    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.processGridData();
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.exportFilteredData = filterBy(this.gridData, this.filter);
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);
        } else { this.aggregateResults = []; }

        if (this.compFeatureFlagSet.featureFlagSet['add-contract-status-open-po-board']) {
            this.contractStatusNameCF = new MSCLFilterClass('contractStatusName', 'contractStatusName', this.gridData);
        }

    }

    rowClassFunction(context: RowClassArgs) {
        let data: ReportConstructionPOInfo = context.dataItem;
        if (data.dateEnteredDays >= 30 && data.blanketAmount <= 0) {
            return { over30: true }
        } else if (data.poTotal == 0 && data.blanketAmount <= 0) {
            if (data.dateEnteredDays >= 30) {
                return { over30: true }
            } else {
                return { zeroDollar: true }
            }
        }
        else if (data.blanketAmount > 0) {
            if (data.isSubContract) {
                if (data.sumAmtPaid === data.blanketAmount) {
                    return { blanketP: true, fullyPaid: true }
                } else { return { blanketP: true } }
            } else {
                if (data.sumAmountBilled === data.blanketAmount) {
                    return { blanketP: true, fullyPaid: true }
                } else { return { blanketP: true } }
            }
        }
        //            inFinance: context.dataItem.inFinance
    }
    tagMapper(tags: any[]): any[] {
        return tags.length < 3 ? tags : [tags];
    }
    details(data: ReportOrderBillInfo) {
        let target: SearchTarget = SearchTarget.order;
        this.dqoiPopup(data.orderId, target, data.isConstruction);
    }

    showDetailsPopup(data: ReportOrderBillInfo, searchTarget: any = SearchTarget.dispatch) {
        let id: any = data.dispatchId;
        if (searchTarget == SearchTarget.order) {
            id = data.orderId;
        }
        if (searchTarget == SearchTarget.invoice) {
            id = data.invoiceId;
        }
        this.dqoiPopup(id, searchTarget, data.isConstruction);
    }
    onClosed() {
        this.showDetails = false;
    }
    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    closeDetail() {

    }
    detailsData: DispatchData;
    dqoiPopup(id: any, target: SearchTarget, isConstruction: boolean = false) {
        let data: DispatchData = new DispatchData();
        data.id = id;
        data.target = target;
        data.isConstruction = isConstruction;
        data.viewDispatch.dispatchId = id;

        this.detailsData = data;
        //this.cpPopWindow({ contentType: WindowContents.viewDispatch, boardData: data });
    }
    public cpActiveChildComp: number;
    public cpWindowData: any;
    public cpShowWindow: boolean = false;
    public saveError: string = null;
    public cpContentTypes = WindowContents;
    cpPopWindow(injected: any) {
        this.cpActiveChildComp = injected.contentType;
        this.cpWindowData = injected.boardData;
        this.cpShowWindow = true;
    }
    onCPWindowClosed(e) {
        this.cpShowWindow = false;
    }

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    public exportGridToExcel(): void {
        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.origData) this.origData = [];
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }

    public getExportData() {
        return this.origData ? this.origData.length : 0;
    }
}
